export default {
	agree: '同意',
	agreeMsg: '协议和隐私政策',
	signupAgree: '同意协议和隐私政策',
	mustAgree: '请先同意协议和隐私政策',
    openapp: '请在浏览器中打开',
	loading: '加载中...',
	add: '新增',
	delete: '删除',
	edit: '修改',
	sort: '排序',
	query: '查询',
	resetting: '重置',
	copy: '复制',
	export: '导出',
	handle: '操作',
	back: '返回',
	confirm: '确定',
	cancel: '取消',
	clear: '清除',
	close: '关闭',
	created_at: '创建时间',
	updated_at: '更新时间',
	required: '必填项不能为空',
	successMsg: '修改成功',
	errorMsg: '修改失败',
	opaSuccess: '操作成功',
	opaError: '操作失败',
	prompt: '提示',
	Enter: '请输入',
	EnterEpt: '提交信息为空',
	PleaseSelect: '请选择',
	Uploadfiles: '上传文件',
	Previewfiles: '预览文件',
	Downloadfiles: '下载文件',
	FileFormats: '支持以下文件格式',
	FileName: '文件名',
	uploaded: '上传时间',
	operator: '操作员',
	previewType: '当前附件不支持预览，请下载后查看',
	DownloadSuccessful: '下载成功',
	DownloadFailed: '下载失败',
	Save: '保存',
	SaveAndNext: '保存并继续',
	nodata: '无数据',
	refundSet: '退款手续费设置',
	refundRate: '退款手续费率',
	commRate: '分佣结算时间',
	commRateUnit: '天',
	refundCustom: '客户承担',
	refundbusiness: '商家承担',
	rateTips: '请输入正确的费率',
	commTips: '请输入正确的天数',
	ProductDetials: '产品详情',
	UserDetials: '用户详情',
	Picture: '产品图片',
	ReceiptNo:'入库单号',
	Creationtime:'创建时间',
	Inboundtime:'入库时间',
	Addnewcustomer:'添加新客户',
	Inputtoselectcustomer:'输入选择客户',
	Customername:'客户名称',
	CustomerTaxNo:'客户编号',
	CustomerPhone:'客户电话',
	Driverphone:'司机电话',
	ShopNo:'店铺编号',
	Shopphone:'店铺电话',
	No:'编号',
	ItemNo:'货号',
	Material:'材料',
	Numberofpackages:'箱数',
	numberofboxes:'装箱数',
	Totalquantity:'总数量',
	GW:'毛重Kg',
	TotalGW:'总重Kg',
	Length:'长cm',
	Width:'宽cm',
	Height:'高cm',
	CBM:'体积m³',
	TotalCBM:'总体积m³',
	Bytrain:'火车',
	Bytruck:'卡车',
	Markcolor:'标记颜色',
	packagingmethod:'包装方法',
	Normal:'正常',
	Compress:'压缩',
	White:'白色',
	Yellow:'黄色',
	input:'输入',
	Total:'总数',
	Cancel:'关闭',
	dashbord1:'今日新入库',
	dashbord2:'今日新装箱单',
	dashbord3:'装箱单待出',
	dashbord4:'仓库中通过火车运输的物品总量',
	dashbord5:'仓库中通过卡车运输的物品总量',
	dashbord6:'未选择运输方式 ',
	dashbord7:'超过X天未更新的客户',
	dashbord8:'总客户数',
	customers1:'总入库次数',
	customers2:'总运输体积',
	customers3:'超过X天未更新',
	Operate:'操作',
	Details:'详情',
	Edit:'编辑',
	Delete:'删除',
	InboundorderNo:'入库单号',
	ProductName:'产品名称',
	MaterialUsage:'使用材料',
	DownloadExcel:'导出为表格',
	DownloadImage:'导出为图片',
	DownloadQRcode:'导出为二维码',
	CopyLink:'复制链接',
	AddtoNewPackinglist:'添加新装箱单',
	AddtoExistentPackinglist:'添加到现有装箱单',
	saveOk:'保存成功',
	ConfirmDelete:'确认删除',
	ConfirmDeleteOk:'你确定要删除这个吗?',
	Confirmoperation:'确认操作吗?',
	app: {
		title: 'kavkaz',
		logoText: 'kavkaz',
		loginText: '管理端登录',
		miniLogoText: 'kavkaz',
		username: '用户名',
		password: '密码',
		captcha: '验证码',
		signIn: '登录',
		Register: '注册',
		signOut: '退出',
		large: '大型',
		default: '默认',
		small: '小型',
		close: '关闭',
		closeOthers: '关闭其它',
		closeAll: '关闭全部'
	},
	settings: {
		title: '布局设置',
		sidebarDark: '暗色侧边栏',
		sidebarLight: '亮色侧边栏',
		navbarLight: '亮色顶栏',
		navbarTheme: '主题色顶栏',
		interface: '界面设置',
		uniqueOpened: '侧栏排他展开',
		logo: '开启LOGO',
		dark: '开启暗黑模式',
		breadcrumb: '开启面包屑',
		tabs: '开启标签页',
		tabsCache: '开启标签页缓存',
		tabsStyle: '标签页风格',
		copyConfig: '复制配置',
		reset: '恢复默认',
		copySuc: '复制成功',
		style1: '风格1',
		style2: '风格2',
		closeTab: '关闭',
		closeOther: '关闭其他',
		Currency: '货币',
		Unit: '单位',
		SystemDepartment: '部门',
		SystemUser: '员工',
		MembershipPrice: '会员价格',
		Supports: '服务信息',
		Help: '帮助',
		Term: '协议',
		Privacy: '隐私',
		Others: '其他配置',
		BaseInfo: '个人资料',
		DepartmentInfo: '部门信息',
		UserName: '用户名称',
		Clipper: '图片裁剪',
		SelectImg: '选择图片',
		Confirmupload: '确定上传',
		UploadImages: '上传图片',
		ReUpload: '重新上传',
		Setting: '设置',
		SystemLanguage: '系统语言',
		DefaultCurrency: '默认产品货币',
		DefaultUnit: '默认产品单位',
		Membership: '会员',
		Support: '服务与支持',
		Upgrade: '升级',
		Vipuser: '大客户',
	},
	table: {
        customerName:'客户姓名',
        customerphone:'客户联系方式',
        customerTax:'客户编号',
		TotalProducts: '所有产品数量',
		LastProductActivityTime: '最后新建/编辑产品时间',
		name: '名称',
		Operation: '操作',
		CurrencyName: '货币名称',
		Symbol: '货币符号',
		SortValues: '排序值',
		UnitName: '单位名称',
		Abbreviation: '缩写',
		DepartmentName: '部门名称',
		WarehouseName: '仓库名称',
		SystemUserID: '员工ID',
		AccountStatus: '账号状态',
		UserName: '员工名称',
		avatar: '头像',
		LoginAccount: '登录账号',
		MembershipName: '会员名称',
		Price: '价格',
		Duration: '期限',
		MembershipDays: '续费天数',
		WebPrice: 'Web价格',
		AndroidPrice: '安卓价格',
		IosPrice: 'IOS价格',
		SupportName: '服务名称',
		PIC: '图片',
		value: '内容',
		SearchDepartmentName: '输入部门名称搜索',
		SearchWarehouseName: '输入仓库名称搜索',
		SearchCustomerName: '输入客户名称搜索',
		SearchUserName: '输入名称搜索',
		SearchLoginName: '输入登录账号搜索',
		Enable: '启用',
		Deactivate: '停用',
		SetPermissions: '设置权限',
		ResetPassword: '重设密码',
		EnterPassword: '请输入新密码',
		PasswordAuthentication: '密码必须包含大小写字母和数字，至少8位。',
		EditPermissions: '编辑权限',
		SelectAll: '全选',
		DeselectAll: '全不选',
		NoPermissions: '无可配置权限',
		ContactInformation: '联系方式',
		LoginPassword: '登录密码',
		AccountEmail: '账号邮箱',
		AccountName: '账号名称',
		AccountPosition: '职位',
		ContactsType: '联系人类型',
		NameCard: '名片',
		CreatedBy: '建立时间',
		EditedBy: '更新时间',
		FileName: '文件名称',
		FileBy: '创建人',
		TotalAmount: '总金额',
		TotalRefund: '已退款金额',
		Gift: '赠送',
		PaymentID: '支付ID',
		PaymentStatus: '支付状态',
		PaymentUserName: '客户姓名',
		UserEmai: '客户邮箱',
		UserPhone: '客户手机号',
		PaymentType: '支付类型',
		PaymentTime: '支付时间',
		PaymentAmount: '支付金额',
		RefundAmount: '退款金额',
		RefundAmountTips: '已扣除手续费',
		PaymentChannel: '支付方式',
		WechatPay: '微信扫码支付',
		PaymentDuration: '开通时长',
		XufeiDuration: '续费时长',
		Picture: '产品图片',
		ProductName: '产品名称',
		ItemNumber: '货号',
		ProductPrice: '价格',
		Unit: '单位',
		Contact: '联系人',
		Tag: '标签',
		Basicinformation: '基础信息',
		MaxImgSize: '图片大小限制：10M',
		UpImgTips: '上传图像时，可以将其裁剪为正方形。裁剪时，可以放大或缩小图像',
		Description: '产品描述',
		hsCode: '海关编码',
		Packinginformation: '包装信息',
		PackingQTY: '包装数量',
		InnerPacking: '内包装',
		PackingSize: '包装尺寸',
		CBM: '体积',
		GrossWeight: '毛重',
		NetWeight: '净重',
		MOQ: '最小起订量',
		Remark: '备注',
		UserID: '客户ID',
		UserAvater: '客户头像',
		UserLink: '客户网站',
		UserRegisterTime: '注册时间',
		LastActivityTime: '上次登录时间',
		Membership: '会员等级',
		UserDuration: '剩余时长',
		Active: '启用',
		Inactive: '禁用',
		pay: '实际支付',
		confirm: '后台确认支付',
		gift: '赠送',
		RegisterSource: '注册来源',
		inviteUser: '邀请人',
		inviteRate: '当前推广分佣比例',
		inviteAmount: '推广分佣总金额',
		inviteAmounTX: '可提现总金额',
		inviteAmountBTX: '不可提现金额',
		inviteAmountYTX: '已提现金额',
		barcode: '条形码',
		addbarcode: '生成条形码',
		savebarcode: '保存',
		enterbarcode: '请输入条形码数字',
		enterbarcodeRight: '请输入正确的条形码',
        Withdrawaltime: '提现时间',
        Withdrawalamount: '提现金额',
        Withdrawalchannels: '提现渠道',
        Withdrawalhandlingfee: '提现手续费',
	},
	operation: {
		NewCurrency: '新建货币',
		NewUnit: '新建单位',
		NewDepartment: '新建部门',
		NewSystemUser: '新建员工',
		ActiveAccounts: '启用账号',
		InactiveAccounts: '停用账号',
		ReleaseAccount: '释放账号',
		ReleaseConfirm: '确定释放账号吗？',
		Renew: '续费',
		All: '全部',
		SearchAccounts: '搜索账号',
		SearchContacts: '搜索联系人',
		SearchPayment: '搜索客户姓名/手机号/邮箱',
		SearchProducts: '搜索产品',
		SearchTags: '搜索标签',
		Buyers: '客户',
		Suppliers: '供应商',
		PaymentStartTime: '支付时间起',
		PaymentEndTime: '支付时间止',
		StartTime: '开始时间',
		EndTime: '结束时间',
		RegisterStartTime: '注册时间起',
		RegisterEndTime: '注册时间止',
		ConfirmPayment: '确认支付',
		Refund: '退款',
		GiftMonth: '一个月',
		GiftYear: '一年',
		NeedSelect: '请选择需要删除的产品',
		NeedSelectExport: '请选择需要导出的产品',
		EnterFileName: '请输入文件名称',
		ChooseAs: '导出选项',
		Quotation: '报价单',
		Packinglist: '装箱单',
		Invoice: '发票',
		ExoprtFile: '导出文件',
		ChoosePic: '请选择产品图片',
		EnterProName: '请输入产品名称',
		TotalUsers: '总客户数',
		Freeze: '冻结',
		Unfreeze: '解冻',
		UserFreeze: '冻结客户',
		UserUnfreeze: '解冻客户',
		FreezeTime: '冻结时长',
		FreezeDay1: '3天',
		FreezeDay2: '7天',
		FreezeDay3: '永久',
        inviteTxBtn: '添加提现记录',
	},
	error: {
		email: '邮箱格式不正确',
		password: '密码不能小于{len}位数',
		captcha: '验证码错误',
		successLogin: '登录成功',
		failLogin: '登录失败',
	},
	router: {
		home: '首页',
		profilePassword: '修改密码'
	},
	menu: {
		PageUser: '客户管理',
		PagePayment: '支付管理',
		PageSettings: '系统设置',
		PagenSystem: '路由配置',
		ChangePassword: '修改密码',
		Me: '个人中心',
		PageProducts: '产品管理',
		PageContacts: '联系人管理',
		PageAccounts: '账号管理',
		PageFile: '文件管理',
		PageMembership: '会员管理',
		ModifyAvatar: '修改头像',
		ModifyName: '修改名称',
		Freeze: '冻结',
		Unfreeze: '解冻',
		ResetPassword: '重置密码',
		Gift: '赠送',
		ConfirmPayment: '确认支付',
		Refund: '退款',
		Currency: '货币',
		Unit: '单位',
		SystemDepartment: '部门',
		SystemUser: '员工',
		MembershipPrice: '会员价格',
		Supports: '服务与支持',
		Vipuser: '大客户',
		Help: '帮助',
		Term: '协议',
		Privacy: '隐私',
		Others: '其他配置',
		add: '新增',
		delete: '删除',
		edit: '修改',
		export: '导出',
		copy: '复制',
		SetPermissions: '设置权限',
		ActiveAccounts: '启用账号',
		InactiveAccounts: '停用账号',
		Renew: '续费',
		ReleaseAccount: '释放账号',
		Buy: '购买会员',
		rate: '设置分佣比例',
		promotion: '推广管理',
		promotionlogs: '推广记录',
        UserTx: '添加提现记录',
        push: '推送管理',
        pushLog: '消息推送记录',
        addPushLog: '新增消息推送',
        dateAnalysis:'数据分析',
        dashbord:'面板',
        customers:'客户',
        receiptM:'入库单',
        newReceipt:'新建入库单',
        receiptDetails:'入库单详情',
        receiptsList:'入库单清单',
        byTrain:'火车运输',
        ByTruck:'卡车运输',
        notChosen:'未选择',
        packingM:'装箱单',
        newPackingList:'新装箱单',
        packingListDetails:'装箱单明细',
        packingLists:'装箱单',
        fileM:'系统',
        deapartment:'部门',
        werehouse:'仓库',
        user:'员工',
        customer:'客户'
	},
	profile: {
		username: '用户名',
		company_name: '公司名称',
		phone: '手机号',
		address: '地址',
		website: '网址',
		oldPassword: '原密码',
		newPassword: '新密码',
		confirmPassword: '确认密码',
		enterNewPassword: '输入新密码',
		minDigits: '密码最少六位',
		enterNewPasswordAgain: '请再次输入新密码',
		inconsistent: '两次密码不一致，请重试输入',
		success: '密码修改成功',
		errorMsg: '您的账号异常，请重新登录后再改密码',
	},
	axios: {
		Uploading: '上传中',
		Submitting: '提交中',
		Sending: '发送中',
		Registering: '注册中',
		Loading: '加载中',
		Saving: '保存中',
		Deleting: '删除中',
		DeleteTips: '确定进行删除操作?',
		buyLoading: '订单提交中',
	},
	login: {
		Email: '邮箱/手机号',
		EmailVer: '请输入正确的邮箱/手机号',
		EmailTips: '请输入邮箱或者手机号',
		EmailSuccess: '我们已向您的电子邮件发送了验证链接。请转到您的电子邮件并单击验证链接以成功注册。',
		EmailReset: '我们已向您的电子邮件发送了重置密码链接。请转到您的电子邮件，然后转到下一个。',
		nameTips: '请输入名称',
		passTips: '请输入密码',
		captchaTips: '请输入验证码',
		goLogin: '去登录',
		goAPP: '在APP内登陆使用',
		ResetPassword: '重置密码',
		EmailName: '邮箱',
		NewPassword: '新密码',
		EnterNewPassword: '请输入新密码',
		ConfirmModification: '确定修改',
		ResetEnd: '密码重置成功，请牢记您的新密码。',
		ClientLogin: '客户端登录',
		ManagementLogin: '管理端登录',
		ForgotPassword: '忘记密码',
		SendCodeOk: '验证码已成功发送，请注意查收。',
		RegisterOk: '注册成功，请牢记您的密码。',
		ResetOk: '已重置，立即登录',
		Resend: '重新发送',
		verCode: '短信验证码',
		EnterCode: '请输入短信验证码',
		sendCode: '发送验证码',
		RegResult: '注册结果',
		ResetResult: '重置结果',
		verEmail: '邮箱验证',
		verSms: '短信验证',
	},
	membership: {
		Free: '免费版',
		Basic: '基础版',
		Company: '企业版',
		Sub: '员工帐号',
		FreePro1: '最多添加5个产品',
		FreePro11: '升级后可无限制添加产品',
		FreePro2: '最多5个导出单',
		FreePro22: '升级后可无限制导出',
		BasicPro1: '无限制添加产品',
		BasicPro2: '无限制导出单',
		BasicPro3: '可以导出为报价单和装箱单',
		CompanyPro1: '管理员帐户+4个员工帐户',
		CompanyPro2: '每个帐户都可以访问相同的产品和文件数据库',
		BuyAccounts: '购买员工帐号',
		BuyPro: '可以增加{year}  {month}的额外账户',
		Agree: '同意付款协议和政策',
		mustAgree: '请选阅读并同意付款协议和政策',
		Month: '月',
		Year: '年',
		Unpaid: '待付款',
		Paid: '已付款',
		PartialRefund: '部分退款',
		Refunded: '已退款',
		Fail: '付款失败',
		ConfirmPayment: '确认支付',
		ConfirmTips: '确认付款赠送用户成员，请谨慎使用',
		GoPay: '订单已创建成功，请前往支付',
		ConfirmPay: '支付确认',
		EndPay: '支付完成',
		Confirm: '确认',
		ConfirmRefund: '确认退款',
		Refund: '退款',
		EnterRefund: '输入退款金额',
		RefundTips: '不能超过付款金额',
		RefundWarning: '退款将收回相应权益',
		ExpireTime: '会员到期时间',
		IsFreezed: '该用户已被冻结',
		InFreezed: '解冻时间：{time}',
		AmountsMax: '新增员工账号次数已用尽',
		AmountsMaxTips: '您可以选择购买更多员工账号',
		paySuccess: '订单已支付成功',
	},
    invite: {
        link: '邀请链接',
        wechat: '微信',
        qq: 'QQ',
        rate: '分佣比例',
        setRate: '首次推广分佣比例',
        setRenRate: '续费分佣比例',
        setRateOne: '一级首次推广分佣比例',
        setRenRateOne: '一级续费分佣比例',
        setRateTwo: '二级首次推广分佣比例',
        setRenRateTwo: '二级续费分佣比例',
        enterTips: '请输入分佣比例(0~100)',
        Inviteraccount: '邀请人账号',
        Invitedpersonaccount: '被邀请人账号',
        Paymenttime: '支付成功时间',
        Paymentamount: '支付金额',
        Paymentchannels: '支付渠道',
        MemberType: '会员类型',
        Commissionamount: '分佣金额',
        canWithdraw: '可提现金额为0',
        searchaccount: '按账号搜索',
        promotion: '我的推广',
        amount: '总金额',
        received: '收入金额',
        withdrawable: '可提现金额',
        type: '客户类型',
        time: '日期',
        commission: '佣金金额',
		editTx: '修改可提现金额',
		editTxNow: '当前可提现金额：',
		editTxTips: '请输入正确的金额',
    },
    push: {
        sub: '提交后不可撤销，确认提交发送吗？',
        add: '提交推送消息',
        request_id: '推送唯一ID',
        title: '推送标题',
        content: '推送内容',
        payload: '推送跳转数据',
        push_clientids: '接收消息用户',
        push_system: '推送系统类型',
        push_result: '推送状态',
        all: '所有平台',
        ios: 'Ios',
        and: 'Android',
        wx: '微信小程序',
        success: '推送成功',
        fail: '推送失败',
        userlist: '接收消息用户列表',
        alluser: '所有用户',
        setuser: '指定用户',
        iosuser: 'Ios用户',
        anduser: 'Android用户',
        nouser: '暂无可接收推送消息的用户',
    }
}
